import type { HistoryTutoringSnapshotFragment } from "api/generated";
import AssignmentBox, { type IAssignment } from "components/AssignmentBox/AssignmentBox";
import BookIcon from "images/icons/18-book.svg";
import { useMemo } from "react";
import { BooleanWithTypeGuard } from "utils/types/BooleanWithTypeGuard";
import { getAdmissionTestLabel } from "utils/common/assignmentDetail";

interface Props {
  tutoring: HistoryTutoringSnapshotFragment;
  date: string;
}

export const TutoringHistory = ({ tutoring, date }: Props) => {
  const formatDate = (dateString: string) => new Date(dateString).toLocaleDateString("cs-CZ");

  const assignments = useMemo<IAssignment[]>(() => {
    const fixedAssignments = tutoring.themeAssignments
      .filter(assignment => assignment.finished)
      .map(assignment => assignment.userAssignmentObject)
      .filter(BooleanWithTypeGuard);
    const otherAssignments = tutoring.assignments
      .filter(assignment => assignment.finished)
      .map(assignment => assignment.userAssignmentObject)
      .filter(BooleanWithTypeGuard);

    return [...fixedAssignments, ...otherAssignments].map(assignment => ({
      id: assignment.id,
      text: assignment.assignment?.assignment?.assignmentText ?? "",
      href: `/historie/doucovani/${tutoring.tutoringId}/${assignment.id}`,
      testId: getAdmissionTestLabel(assignment.assignment?.general?.admissionTest) ?? null,
      testOrder: assignment.assignment?.general?.testOrder ?? null,
      envelopeDot: assignment.envelope ?? undefined,
    }));
  }, [tutoring]);

  return (
    <div className="history">
      <div className="history__header history__header--tutoring">
        <div className="d-flex flex-direction-row gap-2">
          <BookIcon />
          <div>
            <strong>Doučko {formatDate(date)}</strong>
          </div>
        </div>
      </div>

      {assignments.map(assignment => (
        <AssignmentBox key={assignment.id} assignment={assignment} />
      ))}
    </div>
  );
};
